/**
 * 公共方法
 */
exports.install = function (Vue,options){
    var _this=Vue.prototype;
    var Common=Vue.prototype.$common={};
    const publicData =  require('../store/modules').default.data.state;
    /**
     * 在新页面打开
     * @param {*} $this
     * @param {*} routeName
     * @param {*} param 参数对象，对象格式
     */
    Common.OpenNewPage=function($this,routePath,param){
        let routeData=$this.$router.resolve({
            path:routePath,
            query:param
        });
        window.open(routeData.href,'_blank');
    }
    /**
     * 写入sessionStorage
     */
    Common.setSessionStorage=function(key,objData){
        if(typeof objData=='string'){
            sessionStorage.setItem(key,objData);
        }
        else{
            sessionStorage.setItem(key,JSON.stringify(objData));
        }

    }
    /**
     * 读取sessionStorage
     */
    Common.getSessionStorage=function(key,isObj){
        var data= sessionStorage.getItem(key);
        if(isObj){
            return JSON.parse(data);
        }
        return data;
    },
     /**
     * 移除sessionStorage
     */
    Common.removeSessionStorage=function(key){
        sessionStorage.removeItem(key);
    }
    ,
    Common.timestampToTime =function(row, column) {
          var date = row[column.property];
          if (date == undefined) {
             return "/";
          }
        //   return moment(date).format("YYYY-MM-DD HH:mm:ss");
          return moment(Number(date)).format("YYYY-MM-DD");
    },
    Common.monthToTime =function(row, column) {
        var date = row[column.property];
        if (date == undefined) {
           return "/";
        }
      //   return moment(date).format("YYYY-MM-DD HH:mm:ss"); 
        return moment(date).format("YYYY-MM");
    },
    Common.minutetampToTime =function(row, column) {
          var date = row[column.property];
          if (date == undefined) {
             return "/";
          }
          return moment(date).format("YYYY-MM-DD HH:mm");
    },
    //时间格式化
    Common.secondtampToTime =function(row, column) {
        var date = row[column.property];
        if (date == undefined) {
           return "/";
        }
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },

    Common.isSuccess =function(data,callback) {
        if (data && data.data) {
            var json = data.data;
            if (json.status == 'SUCCESS') {
                _this.$message({message: '执行成功',type: "success"});
                callback(json);
            }
            else if (json.message) {
                _this.$message({message: json.message,type: "error"});
            }
        }
        else{
            _this.$message({message: '执行异常，请重试',type: "error"});
        }
    },
    Common.timeFormat = (value, format = 'YYYY-MM-DD HH:mm:ss')=>{
        if (!value) return '/'
        return moment(value).format(format);
    },
    Common.datetampToTime=function(val){
        var date = new Date(val)
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    Common.minutestampToTime=function(val){
        var date = new Date(val)
        return moment(date).format("YYYY-MM-DD HH:mm");
    },
    Common.monthtampToTime=function(val){
        var date = new Date(val)
        return moment(date).format("YYYY-MM-DD");
    },
    Common.mampToTime=function(val){
        var date = new Date(val)
        return moment(date).format("YYYY-MM");
    },
    //图片转化 带token
    Common.imgUrl=function(val){
        if(val){
            let index = val.lastIndexOf('/')
            let valid = val.substring(index)
            if(valid.indexOf('?') != -1){
                valid = valid.split('?')[0]
            }
            return `/jbbcs/file/getUploadFile/${valid}?token=${window.localStorage.getItem('token')}`
         }else{
             return 'static/img/zanwu2.png'
         }
    },


    //图片转化 不带token
    Common.imgPath=function(val){
        if(val){
            let index = val.lastIndexOf('/')
            let valid = val.substring(index)
            return 'https://jbbcs.hzjbqy.cn/justarsFile/' + valid ;
         }else{
             return 'static/img/zanwu2.png'
         }
    },
    //列表查询筛选
    Common.beforeAvaUpload=function(file) {
        var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
        const extension = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        const extension3 = testmsg === 'pdf'
        const extension4 = testmsg === 'docx'
        const extension5 = testmsg === 'doc'
        const extension6 = testmsg === 'png'
        const extension7 = testmsg === 'jpg'
        if(!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7) {
            this.$message({
                message: '上传文件只能是:PDF、Word、Excel Png Jpg 格式!',
                type: 'warning'
            });
            return
        }
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isLt2M) {
             alert('上传文件大小不能超过 10MB!')
            // this.$emit('handleImgTips','上传图片大小不能超过 10MB!')
            return false
        }
    }


    //图片回显处理 数组 带token
    Common.imgArray=function(val){
        if(val){
            var urlArray = [];
            var imgArr = val.split(',');
            imgArr.forEach(item=>{
                let imgObj={
                    name:'图片',
                    url:publicData.showFileToken+item+'?token='+window.localStorage.getItem("token_trade_manage")
                }
                urlArray.push(imgObj);
            })
            return urlArray
         }
    },


    //隐藏姓名
    Common.plusXing=function(str,frontLen,endLen){
        // str要隐藏的变量   frontLen 前面需要保留几位  endLen 后面需要保留几位
        var len = str.length-frontLen-endLen;
        var xing = '';
        for (var i=0;i<len;i++) {
        xing+='*';
        }
        return str.substring(0,frontLen)+xing+str.substring(str.length-endLen);
    }




    //时间戳
    Common.transdate=function(val){
            var date = new Date(val);
          // 有三种方式获取
             var time1 = date.getTime();
             var time2 = date.valueOf();
             var time3 = Date.parse(date);
         return time1
    }


    Common.monthtampFullDate=function(val){
                var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-'
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
                var D = (date.getDate()< 10 ? '0'+(date.getDate()) : date.getDate())
                return Y+M+D
            },



    //table合并行通用
    Common.mergeTableRow=function(data, merge){
         if (!merge || merge.length === 0) {
            return data
          }
          merge.forEach((m) => {
            const mList = {}
            data = data.map((v, index) => {
              const rowVal = v[m]
              if (mList[rowVal] && mList[rowVal].newIndex === index) {
                    mList[rowVal]['num']++
                    mList[rowVal]['newIndex']++
                    data[mList[rowVal]['index']][m + '-span'].rowspan++
                    v[m + '-span'] = {
                        rowspan: 0,
                        colspan: 0
                    }
              } else {
                    mList[rowVal] = { num: 1, index: index, newIndex: index + 1 }
                    v[m + '-span'] = {
                        rowspan: 1,
                        colspan: 1
                    }
              }
              return v
            })
          })
          return data
    }
    
     //付款方式
     Common.paymentWayFilter=function(val){
        val = String(val);
        if(val=="1"){
        return "微信"
        }else if(val=="2"){
            return "支付宝"
        }else if(val=='5'){
            return "企业支付宝"
        }else if(val=="6"){
            return "对公"
        }else if(val=="7"){
            return "联合银行(黄功成)"
        }else if(val=="8"){
            return "联合银行(孙玉芝)"
        }else if(val=="9"){
            return "淘宝(济邦邦)"
        }else if(val=="10"){
            return "工商银行(对公银行)"
        }else if(val=="11"){
            return "企业微信"
        }else if (val == "12") {
            return "农业银行(爱华对公)"
        } else if (val == "13") {
            return "支付宝(爱华)"
        }else if (val == "14") {
            return "权驿站微信"
        }else if (val == "15") {
            return "权驿站支付宝"
        }else if (val == "16") {
            return "工商银行(权驿站对公)"
        }else if (val == "19") {
            return "正潮（工行对公）"
        }
    }
    Common.getImageList = (id,url) =>{
        if(!id || !url) return []
        let idList = String(id).split(",");
        let urlList =url.split(",");
        let imageList = []
        idList.forEach((item, index) => {
            let file = urlList[index]
            file&&imageList.push({
                name: '文件' + ( index + 1 ) + '.' + file.split(".")[1],
                id: item,
                url: Common.imgUrl(file),
            });
        });
        return imageList
    }
    /**
    * 防抖
    * @param {Function} func 要执行的回调函数
    * @param {Number} wait 延时的时间
    * @param {Boolean} immediate 是否立即执行
    * @return null
    */
   let timeout;
   Common.Debounce = (func, wait=300, immediate = false) => {
     // 清除定时器
     if (timeout !== null) clearTimeout(timeout);
     // 立即执行，此类情况一般用不到
     if (immediate) {
       var callNow = !timeout;
       timeout = setTimeout(function() {
         timeout = null;
       }, wait);
       if (callNow) typeof func === 'function' && func();
     } else {
       // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
       timeout = setTimeout(function() {
         typeof func === 'function' && func();
       }, wait);
     }
   }
   /**
    * 节流
    * @param {Function} func 要执行的回调函数
    * @param {Number} wait 延时的时间
    * @param {Boolean} immediate 是否立即执行
    * @return null
    */
   let timer, flag;
   Common.throttle = (func, wait = 300, immediate = true) => {
     if (immediate) {
       if (!flag) {
         flag = true;
         // 如果是立即执行，则在wait毫秒内开始时执行
         typeof func === 'function' && func();
         timer = setTimeout(() => {
           flag = false;
         }, wait);
       }
     } else {
       if (!flag) {
         flag = true
         // 如果是非立即执行，则在wait毫秒内的结束处执行
         timer = setTimeout(() => {
           flag = false
           typeof func === 'function' && func();
         }, wait);
       }
     }
   }
   Common.arraySpanMethod = (table,tableData,key,tabIndex = 0) => {
        // table 当前行 tableData 表格数据 key 要合并的列的prop tabIndex 位于第几列
        let flitterData = (arr) =>{
            let spanOneArr = []
            let concatOne = 0
            arr.forEach((item, index) => {
                if (index === 0) {
                    spanOneArr.push(1);
                } else {
                    if (item && arr[index - 1] && item[key] === arr[index - 1][key]) {
                        spanOneArr[concatOne] += 1;
                        spanOneArr.push(0);
                    } else {
                        spanOneArr.push(1);
                        concatOne = index;
                    }
                }
            })
            return {
                spanOneArr
            }
        }
        if (table.columnIndex === tabIndex) {
            const _row = (flitterData(tableData).spanOneArr)[table.rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col
            }
        }else if(table.column.property == 'result'){
            if (table.rowIndex != 0) {
                return {
                    rowspan: 0,
                    colspan: 0,
                }
            }
            return {
                rowspan:tableData.length,
                colspan:1
            }
        }else{
            return false
        }
    },
    //时间格式化
    Common.defaultVal =function(row, column) {
        var val = row[column.property];
        if (val == undefined || val == null || !val) {
           return "/";
        }else{
            return val
        }
    },
    // 下载文件
    Common.downFile = (a,b)=>{
        let downloadFileByBase64 = (base64Str, fileName) => {
            var myBlob = dataURLtoBlob(base64Str)
            var myUrl = URL.createObjectURL(myBlob)
            downloadFile(myUrl, fileName)
        }
        /**封装base64Str blob对象*/
        let dataURLtoBlob = (base64Str) => {
            var bstr = atob(base64Str), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr]);
        }
        /**创建一个a标签，并做下载点击事件*/
        let downloadFile = (hrefUrl, fileName) => {
            const a = document.createElement("a")
            a.href = hrefUrl
            a.download = fileName || `数据.xls`
            a.click()
            a.remove()
        }
        return downloadFileByBase64(a,b)
    },
    Common.expenseTypeText = (row, column)=>{
        var val = row[column.property];
        let res = publicData.expenseTypeList.find(v=> v.value == val) 
        return res ? res.label : '/'
    },
    Common.tableIndex = (scope,current,size)=>{
        return  ( current - 1 ) * size + scope.$index + 1
    },
    Common.getRandomKey = (len = 32)=>{
        len = len;
        /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = $chars.length;
        let pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    },
    // 字符回显
    Common.textFilter = (val = '',arr = [],def = '')=>{
		if(val){
			let _val = []
			let list = []
			if(typeof val == 'string'){
				_val = val.split(',')
			}else if(typeof val == 'object'){
				_val = val
			}else if(typeof val == 'number'){
                _val = [val]
            }
			_val.forEach(v=>{
				let res = arr.find(c=> c.value == v)
				if(res) list.push(res.label || res.text)
			})
			return list.join(',')
		}else{
			return def
		}
	},
    // 获取字典值
    Common.getDict = (typeCode) =>{
        return new Promise(resolve=>{
            _this.$axios({
                url:'/jbb-data/sys/system/enum-dict/list',
                method:'get',
                params:{ typeCode }
            }).then(res=>{
                if(res.data.code == '200'){
                    let arr = res.data.data.map(v=>{
                        v.label = v.dictName
                        v.value = v.dictCode
                        return v
                    })
                    resolve(arr)
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/common/util.js